export const PauseCommandName = 'PauseCommandComponent';
